<template>
    <div>
        <div class="card border-primary mb-3" v-if="model">
            <div class="card-body">
                <div>
                    <i class="fas fa-shield-alt mr-2"></i><span>{{model.description}}</span>
                </div>
                <div>
                    <i class="far fa-clock mr-2"></i><span>{{model.time ? moment(model.time).format('DD.MM.YYYY HH:mm:ss') : ''}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import { ActionLogModel } from '../../../models/models';
    import { Culture } from '../../../models/enums';

    export default {
        props: {
            log: {
                type: [ActionLogModel, Object],
                required: true
            }
        },
        data() {
            return {
                moment: moment,
                model: new ActionLogModel(this.log)
            }
        },
        computed: {
            isEnVersion() {
                return this.$store.getters.currentCulture === Culture.EN;
            },
        }
    }
</script>

<style scoped>

</style>
